export const ERP_SESSION_KEY = 'erp_session';
export const ERP_ROLE_KEY = 'erp_role';
export const ERP_ROLES = ['manager', 'planner', 'operator'];

export const normalizeErpRole = (value) => (ERP_ROLES.includes(value) ? value : 'operator');

const dispatchRoleChanged = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event('erp-role-changed'));
};

export const toStoredErpSession = (profile) => {
  if (!profile) return null;

  return {
    erp_user_id: profile.id || null,
    email: profile.email?.toLowerCase?.() || null,
    role: normalizeErpRole(profile.role),
    session_token: profile.session_token || null,
    session_expires_at: profile.session_expires_at || null
  };
};

export const persistStoredErpSession = (profile) => {
  if (typeof window === 'undefined') return;

  const sessionPayload = toStoredErpSession(profile);
  if (!sessionPayload) return;

  window.localStorage.setItem(ERP_SESSION_KEY, JSON.stringify(sessionPayload));
  window.localStorage.setItem(ERP_ROLE_KEY, sessionPayload.role);
  dispatchRoleChanged();
};

export const clearStoredErpSession = () => {
  if (typeof window === 'undefined') return;

  window.localStorage.removeItem(ERP_SESSION_KEY);
  window.localStorage.removeItem(ERP_ROLE_KEY);
  dispatchRoleChanged();
};

export const readStoredErpSession = () => {
  if (typeof window === 'undefined') return null;

  const raw = window.localStorage.getItem(ERP_SESSION_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    return {
      erp_user_id: parsed?.erp_user_id || null,
      email: parsed?.email?.toLowerCase?.() || null,
      role: normalizeErpRole(parsed?.role),
      session_token: parsed?.session_token || null,
      session_expires_at: parsed?.session_expires_at || null
    };
  } catch {
    return null;
  }
};
